import Slider from "./Slider";
import Section from "../layout/Section";
import Title from "../layout/Title";
import React from "react";

const Waarom: React.FC = () => {
    return (
        <>
            <Section>
                <Title title='Waarom Cohesian?'>
                    <p className="text-inter-lg color-gray-600 mt-30">
                        Wij combineren graag onze enthousiasme, ondernemingszin en expertise
                        om <strong>impact</strong> en <strong>innovatie</strong> te
                        creëren in uw projecten.
                    </p>
                </Title>
                <Slider/>
            </Section>
        </>
    );
};

export default Waarom;
